// hooks/useDocumentTitle.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const routeConfig = {
  '/': { title: '天地源', icon: '/tdytitle.ico' },
  '/auth': { title: '天地源 | 登录', icon: '/tdytitle.ico' },
  '/control-panel': { title: '天地源 | 控制面板', icon: '/tdytitle.ico' },
 
};

export function useDocumentTitle(defaultTitle = '我的应用') {
  const location = useLocation();
  
  useEffect(() => {
    const routeInfo = routeConfig[location.pathname] || { title: defaultTitle };
    
    // 设置页面标题
    document.title = routeInfo.title;
    
    // 动态修改favicon
    const changeFavicon = (href) => {
      const link = document.querySelector("link[rel*='icon']") || 
                   document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = href;
      document.head.appendChild(link);
    };
    
    if (routeInfo.icon) {
      changeFavicon(routeInfo.icon);
    }
    
    // 可选：路由变化时更新meta标签
    const updateMetaTag = (name, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    
    updateMetaTag('description', `这是${routeInfo.title}页面`);
    
  }, [location, defaultTitle]);
}